import React from "react";

export type NamingPhase = "idle" | "creating" | "leaving";

export interface NamingMessage {
  kind: "warn" | "error";
  content: React.ReactNode;
}

/// Characters, not UTF-16 units — the server counts `chars()` after its trim.
export const nameLength = (name: string): number => [...name.trim()].length;

export const overLimitMessage = (
  length: number,
  maxChars: number,
): NamingMessage => ({
  kind: "error",
  content: `${length - maxChars} over the ${maxChars}-character limit`,
});

/// For a create that failed without the server saying why.
export const retryMessage = (what: string): NamingMessage => ({
  kind: "error",
  content: (
    <>
      Couldn&apos;t create the {what}. Press <kbd className="naming-key">↵</kbd>{" "}
      to try again.
    </>
  ),
});

// A create that fails at once (the stack is down) would leave the card looking
// untouched, so a retry would seem to do nothing.
const MIN_ATTEMPT_MS = 400;

/// Resolves once "Creating" has shown for long enough to read as an attempt.
export const attemptShown = (startedAt: number): Promise<void> =>
  new Promise((resolve) =>
    setTimeout(
      resolve,
      Math.max(0, startedAt + MIN_ATTEMPT_MS - performance.now()),
    ),
  );
